import { DashboardComponentPair } from "../../../../models/dashboard";
import { WorkflowDashboardComponent } from "./workflow-dashboard.component";
import { WorkflowDashboardFormComponent } from "./workflow-dashboard-form.component";

export const ComponentPair: DashboardComponentPair = {
    view: WorkflowDashboardComponent,
    form: WorkflowDashboardFormComponent,
}
